var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-head-btn",on:{"click":_vm.click}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('img',{attrs:{"src":require(`@/assets/${_vm.img}`),"alt":"img"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }